import Styled from 'styled-components'
import { Center } from '../generals'

export const Centralize = Styled(Center)`
    position: relative;
    z-index: 1;
    background: white;
    margin-bottom: 5.3rem;
`
